// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { SetStateAction, useState, useContext } from "react";
import { Dropdown, Search } from "@carbon/react";
import AuthContext from "../../store/authContext";
import {
  TABLE_SEARCH_TRANSLATIONS,
  HEX_INPUT_TRANSLATIONS,
} from "../../translations/util";
import SearchContext from "../../store/searchContext";

const hexToDecimal = (hex: string) => parseInt(hex, 16);
const convertToDecimal = (value: string) => parseInt(value, 10);

export const decimalToHex = (num: string) => {
  const dec = convertToDecimal(num);
  if (Number.isNaN(dec)) return `0x${num.toString(16)}`;
  return `0x${dec.toString(16)}`;
};

const SearchTable = (props: {
  selectedColumn: { id: string; value: string } | null;
  setSelectedColumn: React.Dispatch<
    SetStateAction<{ id: string; value: string } | null>
  >;
  filterColumnList: Array<{ id: string; value: string }>;
  searchFunction: (searchTerm?: string) => void;
}) => {
  const {
    selectedColumn,
    setSelectedColumn,
    filterColumnList,
    searchFunction,
  } = props;

  const { hexMode } = useContext(AuthContext);
  const items = [HEX_INPUT_TRANSLATIONS.HEX, HEX_INPUT_TRANSLATIONS.DEC];
  const [currentItem, setCurrentItem] = useState(hexMode ? items[0] : items[1]);
  const { searchText, disableSearch, setSearchText, setDisableSearch } =
    useContext(SearchContext);

  const showHex =
    selectedColumn?.value === "Radio Frequency Subsystem ID" ||
    selectedColumn?.value === "Radio System ID" ||
    selectedColumn?.value === "Radio Wide Area Communications Network ID";

  const handleSearchedHexValue = () => {
    if (
      showHex &&
      currentItem === "HEX" &&
      searchText &&
      !searchText.includes("0x")
    ) {
      return decimalToHex(searchText);
    }
    if (
      showHex &&
      currentItem === "DEC" &&
      searchText &&
      searchText.includes("0x")
    ) {
      return hexToDecimal(searchText);
    }
    return searchText;
  };

  return (
    <div className="search-bar">
      <div className="search-dropdown">
        <Dropdown
          items={filterColumnList}
          itemToString={(item) => (item ? item.value : "")}
          selectedItem={selectedColumn}
          label={TABLE_SEARCH_TRANSLATIONS.label}
          type="inline"
          onChange={(item: { selectedItem: { id: string; value: string } }) => {
            setSelectedColumn(item.selectedItem);
            setSearchText("");
            searchFunction();
            return setDisableSearch(false);
          }}
          data-cy="search-dropdown"
        />
        {showHex ? (
          <Dropdown
            className="input-dropdown"
            label={HEX_INPUT_TRANSLATIONS.dropdownLabel}
            items={items}
            selectedItem={currentItem}
            onChange={({ selectedItem }) => {
              setCurrentItem(selectedItem);
            }}
          />
        ) : null}
      </div>

      <div className="search-input">
        <Search
          closeButtonLabelText={TABLE_SEARCH_TRANSLATIONS.closeButtonLabelText}
          placeholder={TABLE_SEARCH_TRANSLATIONS.placeholder}
          role="searchbox"
          size="lg"
          disabled={disableSearch}
          value={handleSearchedHexValue()}
          onChange={(e: {
            target: { value: React.SetStateAction<string | null> };
          }) => setSearchText(e.target.value)}
          onKeyDown={(e: { key: string }) => {
            if (e.key === "Enter" || e.key === "Tab") {
              if (showHex && searchText.includes("0x")) {
                if (searchText) {
                  searchFunction(hexToDecimal(searchText.trim()));
                } else {
                  searchFunction();
                }
              } else {
                searchFunction(searchText?.trim());
              }
            }
          }}
          data-cy="searchbox"
          onClear={() => searchFunction()}
        />
      </div>
    </div>
  );
};
export default SearchTable;
